module.exports = __webpack_public_path__ + "static/images/confirmPopupHeader.09ef232.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/ssk/confirmPopupHeader.png
// module id = Hk08
// module chunks = 0